<template>
  <div
    class="switch_input"
    tabindex="0"
    :class="{
      small: small,
      disabled: disabled,
      'switch_input--is-true': value,
    }"
    @click="disabled ? '' : toggle()"
    @keydown.enter.prevent="toggle"
    @keydown.space.prevent="toggle"
  >
    <div class="switch_input_hitbox"></div>
    <div class="switch_input__rail">
      <div class="switch_input__thumb">
        <div class="switch_input__thumb-foreground"></div>
        <div :class="{ 'switch_input__thumb-background': !disabled }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseComponent from "../../BaseComponent";
import InteractiveElement from "../../mixins/InteractiveElements";
import InputBase from "./mixins/InputBase";

/**
 * @group Inputs
 * A basic toggle, like seen in setting menus on smartphones.
 */
export default {
  mixins: [BaseComponent, InputBase, InteractiveElement],
  name: "SwitchInput",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      isValid: true,
    };
  },
  methods: {
    toggle() {
      // Toggles Checkbox checked
      if (this.value === true) {
        this.setFalse();
      } else {
        this.setTrue();
      }
    },
    setTrue() {
      // Set Checkbox to checked
      this.inputValue = true;
    },
    setFalse() {
      // Set Checkbox to unchecked
      this.inputValue = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../style_variables/style_variables.scss";
.switch_input {
  position: relative;
  width: 60px;
  height: 31px;
  border-radius: 16px;
  background-color: $white;
  border: 2px solid $grey_french;
  transition: 220ms ease-out;
  &:hover {
    cursor: pointer;
    .switch_input__thumb-background {
      transform: scale(1);
    }
  }
  // True State
  &.switch_input--is-true {
    background-color: $blue;
    border-color: $blue;

    &:hover {
      .switch_input__thumb-background {
        background-color: rgba($blue, 0.25);
      }
    }
    .switch_input__thumb {
      transform: translateX(29px);
    }
  }
}
.switch_input_hitbox {
  position: absolute;
  z-index: 2;
  width: 80px;
  height: 41px;
  margin: -6px -10px;
}
.switch_input__rail {
  width: 100%;
  height: 27px;
}
.switch_input__thumb {
  @include elevationLevel(4);
  position: relative;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  margin-right: 0px;
  transition: 100ms ease-out;
}
.switch_input__thumb-foreground {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: $white;
  border-radius: 50%;
}
.switch_input__thumb-background {
  position: absolute;
  z-index: 1;
  width: 47px;
  height: 47px;
  background-color: rgba($grey_french, 0.25);
  margin: -10px -10px;
  border-radius: 50%;
  transform: scale(0.3);
  transition: 220ms ease-out;
}

.small {
  &.switch_input {
    width: 40px;
    height: 20px;
    background-color: $grey_athens;
    border: 2px solid $grey_athens;
    &.switch_input--is-true {
      background-color: $blue;
      border-color: $blue;
      .switch_input__thumb {
        transform: translateX(20px);
      }
      &.disabled {
        background-color: $grey_athens;
        border-color: $grey_athens;
      }
    }
    & .switch_input {
      &_hitbox {
        height: 35px;
        width: 60px;
      }
      &__rail {
        height: 16px;
      }
      &__thumb {
        box-shadow: 0px 2px 4px rgba(29, 31, 33, 0.2);
        width: 16px;
        height: 16px;
        &-background {
          width: 30px;
          height: 30px;
          margin: -7px -7px;
        }
      }
    }
  }
}
</style>
